<!-- eslint-disable -->
<template lang="pug">
    .game-content
        .menu(v-if="currentPlayersAmount >= 1")
            multiplayer-menu(
                :slug="type",
                @commonParametersHasChanged="handleCommonParametersChange",
                @playersAmountChanged="handlePlayersAmountChange",
                :same-settings-are-active="sameSettingsAreActive",
                @changeGameState="handleGameStateChange",
                @refreshGame="invokeRefreshGameEvent",
                @checkAnswers="invokeCheckAnswersEvent",
                @continueGame="invokeContinueGameEvent",
                :check-answers-ready="isCheckAnswersReady",
                :players-ready-to-answer="arePlayersReadyToAnswer",
                :is-countdown="isCountdown"
            )
        games-wrapper(
            :common-parameters-changer-counter="commonParametersChangerCounter"
            :type="type"
            :exercise-id="exerciseId"
            :homework-id="homeworkId"
            :show-turtle="showTurtle"
            @showTurtle="showTurtle = $event"
            @setMotion="motion = $event"
            :players-number="currentPlayersAmount"
            :check-multiplayer-answers="checkMultiplayerAnswers"
            :play-again="playAgain"
            @playAgainReady="$event ? playAgainReadyScreens++ : playAgainReadyScreens--"
            @checkAnswersReady="handleCheckAnswersReadyEvent"
            :multiplayer-games-state="multiplayerGamesState"
            :continue-game-event="continueGameEvent"
            :refresh-game-event="refreshGameEvent"
            @isCountdownActive="handleIsCountdownActive"
        )
</template>

<script>
    /*eslint-disable*/
    import PlayBox from './PlayBox.vue';
    import GamesWrapper from '../GamesWrapper.vue';
    import MultiplayerCommonMenuMixin from '../../../../utils/multiplayer/commonMenuMixin';

    export default {
        props: ['exerciseId', 'homeworkId', 'type', 'sameSettingsAreActive'],
        mixins: [MultiplayerCommonMenuMixin],
        data () {
            return {
                motion: null,
                showTurtle: true,
                playAgain: false,
                checkAnswersReadyScreens: 0,
                answersChecked: false,
                isCountdown: false
            }
        },
        methods: {
            sendPlayAgainEvent () {
                this.playAgain = true;
                this.$nextTick(() => {
                    this.playAgain = false;
                });
            },
            handleCurrentGameParametersChange (parameter) {
                let newParamsArray = this.paramsArray;
                newParamsArray.forEach(params => {
                    if (parameter.setOptionsValues) {
                        //handling change of 'onlyAddition\onlySubtraction' modes for options
                        parameter.subNames.forEach((subName, index) => {
                            params[parameter.name][subName] = parameter.values[index];
                        });
                        return;
                    }
                    params[parameter.name] = parameter.value;
                });
                this.$store.dispatch('setParamsArray', newParamsArray);
            },
            handleIsCountdownActive (isActive) {
                this.isCountdown = isActive;
            },
        },
        components: {
            PlayBox,
            GamesWrapper,
        },
        beforeRouteLeave (to, from, next) {
            if (this.$store.state.trainer.game) {
                if (!(to.meta.type && to.meta.type === 'trainer')) {
                    this.$store.dispatch('setHomework', null);
                    this.$store.dispatch('setGame', null);
                }
            }
            next();
        }
    }
</script>

<style lang="scss" scoped>
    .menu {
        width: 100%;
        margin-bottom: 20px;
        user-select: none;
    }

    @import "@/assets/sass/games/main.scss";
</style>
